import AuthRepository from '@/business/modules/auth/auth.repository';
import type {
	IAdminLoginResponse,
	IAdminRecoveryCodeLoginPayload,
	IAdminTotpLoginPayload,
	IAdminTotpLoginResponse,
	IRegisterUserRequest,
	IRegisterUserResponse,
	IUpdateUserInformation,
	IVerifyOtpResponse,
	ISwitchContextRequest,
	ISwitchContextResponse,
} from '@/business/modules/auth/auth.model';

class AuthService {
	static #instance: AuthService;
	private readonly repository;

	private constructor() {
		this.repository = AuthRepository.getInstance();
	}

	public static getInstance(): AuthService {
		if (!AuthService.#instance) {
			AuthService.#instance = new AuthService();
		}

		return AuthService.#instance;
	}

	signup(data: IRegisterUserRequest): Promise<IRegisterUserResponse> {
		return this.repository.signup(data);
	}

	signupForReservation(data: IRegisterUserRequest): Promise<IRegisterUserResponse> {
		return this.repository.signupForReservation(data);
	}

	loginInit(phoneNumber: string) {
		return this.repository.loginInit(phoneNumber);
	}

	loginInitForReservation(phoneNumber: string) {
		return this.repository.loginInitForReservation(phoneNumber);
	}

	verifyOtp(otpCode: string): Promise<IVerifyOtpResponse> {
		return this.repository.verifyOtp(otpCode);
	}

	loginAsAdmin(otpCode: string): Promise<IAdminLoginResponse> {
		return this.repository.loginAsAdmin(otpCode);
	}

	verifyAdminTotpLogin(payload: IAdminTotpLoginPayload): Promise<IAdminTotpLoginResponse> {
		return this.repository.verifyAdminTotpLogin(payload);
	}

	verifyAdminRecoveryCodeLogin(payload: IAdminRecoveryCodeLoginPayload): Promise<IAdminTotpLoginResponse> {
		return this.repository.verifyAdminRecoveryCodeLogin(payload);
	}

	updateUserInformation(userData: IUpdateUserInformation) {
		return this.repository.updateUserInformation(userData);
	}

	loginByRefreshToken() {
		return this.repository.loginByRefreshToken();
	}

	logout() {
		return this.repository.logout();
	}

	getUserInformation() {
		return this.repository.getUserInformation();
	}

	getAvailableContexts() {
		return this.repository.getAvailableContexts();
	}

	switchContext(data: ISwitchContextRequest): Promise<ISwitchContextResponse> {
		return this.repository.switchContext(data);
	}
}

export default AuthService;
